import { actionTypes } from '../actions/account.action';
const initialState = {
    accounts: {
        data: []
    },
    chart: {
        period: {
            period_chart: [],
            today: {}, 
            campaigns: [],
            stats: {}
        },
        hour: {
            best_hour: {},
            best_window: {},
            hourly_chart: [],
            campaigns: [],
        },
        account: {}
    },
    account: {
        gateway: null,
        rate: 'parcial',
        require_cpf: true,
        require_email: true
    },
    error: {},
    success: false
}


const accountReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:
        return { ...state, ...payload }

    case actionTypes.CHART:
        return {
            ...state,
            chart: {
                account: payload?.account,
                period: {
                    ...state.chart.period,
                    ...payload.period
                },
                hour: {
                    ...state.chart.hour,
                    ...payload.hour
                }
            }
        }

    case actionTypes.DESTROY:
        state.accounts.total = state.accounts.total - 1

        return {
            ...state,
            accounts: {
                ...state.accounts,
                data: state.accounts.data.filter(item => item.id !== payload)
            }
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            account: (payload === 'clear') ? {
                gateway: null,
                rate: 'parcial',
                require_cpf: true,
                require_email: true
            } : {
                ...state.account,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default accountReducer